export default function PHP_connect_error() {
  return (
    <div>
      <h1>PHP_connect_error</h1>
    </div>
  );
}
